module.exports = __webpack_public_path__ + "2f70bc9238f3b13300afb7189e243d3a.svg";